import { CustomEventNames, EventTypes, logEvent } from 'features/analytics';

export const logPromotionalEmailPreferenceChanged = (emailMarketingOptIn: boolean) => {
  logEvent(CustomEventNames.SIGN_UP_PROMOTIONAL_EMAILS_CHANGED, EventTypes.Other, {
    checked: emailMarketingOptIn,
  });
};
